import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../contexts/AuthContext";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (attempts++ >= 15) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid]);

  return (
    <div className="min-h-screen bg-black text-white grain">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
        {status === "checking" && (<>
          <Loader2 className="mx-auto animate-spin text-[#eab308]" size={48} />
          <h1 className="mt-6 font-display text-3xl uppercase font-bold">Confirming payment…</h1>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 className="mx-auto text-[#2A9D8F]" size={64} />
          <h1 className="mt-6 font-display text-4xl uppercase font-bold">Payment confirmed</h1>
          <p className="mt-3 text-white/70">Your subscription is active. Head back to your dashboard to unlock the pipeline.</p>
          <Link to="/dashboard"><Button className="mt-8 bg-[#e65f2b] hover:bg-[#c54a1c] text-black font-bold uppercase tracking-widest rounded-sm h-11 px-8" data-testid="success-back-btn">Go to dashboard</Button></Link>
        </>)}
        {(status === "timeout" || status === "error") && (<>
          <XCircle className="mx-auto text-red-500" size={64} />
          <h1 className="mt-6 font-display text-3xl uppercase font-bold">Payment pending</h1>
          <p className="mt-3 text-white/70">We couldn&apos;t confirm the payment yet. It may take a moment — check back or contact support.</p>
          <Link to="/billing"><Button variant="outline" className="mt-8 border-white/20 hover:bg-white/10 rounded-sm h-11 px-8 uppercase tracking-widest">Back to billing</Button></Link>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-black text-white grain">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto text-white/50" size={64} />
        <h1 className="mt-6 font-display text-3xl uppercase font-bold">Checkout cancelled</h1>
        <p className="mt-3 text-white/70">No worries — nothing was charged. Try again when you&apos;re ready.</p>
        <Link to="/billing"><Button className="mt-8 bg-[#e65f2b] hover:bg-[#c54a1c] text-black font-bold uppercase tracking-widest rounded-sm h-11 px-8">Back to billing</Button></Link>
      </div>
    </div>
  );
}
